import { render } from "./ParaAcademique.vue?vue&type=template&id=305d3a15&scoped=true&ts=true"
import script from "./ParaAcademique.vue?vue&type=script&lang=ts"
export * from "./ParaAcademique.vue?vue&type=script&lang=ts"

import "./ParaAcademique.vue?vue&type=style&index=0&id=305d3a15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305d3a15"]])

export default __exports__